import initialState from './initialState';
import { ActionType } from './action';

function privacyPolicyReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ActionType.RECEIVE_PRIVACY_POLICY:
      return {
        ...state,
        privacyPolicy: action.payload.privacyPolicy,
      };
    case ActionType.SET_IS_LOADING_PRIVACY_POLICY:
      return {
        ...state,
        isLoading: action.payload.isLoading,
      };
    case ActionType.SET_IS_ERROR_PRIVACY_POLICY:
      return {
        ...state,
        isError: action.payload.isError,
      };
    default:
      return state;
  }
}

export default privacyPolicyReducer;
